<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="fecharModal" :title="prefix + title">
    <div>
      <b-form @submit.prevent="salvar">
        <b-row>
          <b-col>
            <b-card>
              <b-form-row>
                <img v-if="mostrarImagem" class="mt-3 ml-4 img-fluid" :src="form.imagem"
                  style="max-height: 100px !important" />
              </b-form-row>

              <b-form-row class="mt-4">
                <b-col cols="9" class="ml-3">
                  <input type="file" class="form-control" id="imagemInput" accept="image/*"
                    @change="visualizarImagem" />
                </b-col>
              </b-form-row>

              <b-form-row class="mt-3">
                <b-col cols="10" class="text-left">
                  <lg-form-input invalidFeedback="Informe o nome" description="" v-model="form.nome" label="Nome: *"
                    maxlength="200" />
                </b-col>
              </b-form-row>

              <b-form-group label-for="radio" class="ml-3">
                <b-form-row>
                  <label class="mr-2 text-reset">Status: *</label>
                  <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
                    class="d-flex">
                  </b-form-radio-group>
                </b-form-row>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-center mt-3">
          <b-button id="salvarModelo" type="submit" variant="success" style="height: 30px" pill size="sm">
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
            <b-tooltip target="salvarModelo" title="Salvar" triggers="hover"></b-tooltip>

          </b-button>
          <b-button id="cancelarModelo" class="ml-2" @click="fecharModal" style="height: 30px" pill size="sm"
            variant="danger">
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
            <b-tooltip target="cancelarModelo" title="Cancelar" triggers="hover"></b-tooltip>
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>
<script>
import FotoProdutoService from "@/core/api/FotoProdutoService"
import AceitarIcon from "@/core/assets/icons/aceitar.png"
import FecharIcon from "@/core/assets/icons/fechar.png"
import { getContext } from "@/core/auth"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"

export default {
  components: {
    LgFormInput,
  },
  mixins: [FormResourceMixin, ListResourceMixin],
  props: {
    id: Number,
    modal: Boolean,
    idFoto: {
      type:Number,
      default: null,
    },
    title: { type: String, default: "Cadastro" },
    prefix: { type: String, default: "" },

  },
  data() {
    return {
      showModal: true,
      imgAceitar: AceitarIcon,
      imgFechar: FecharIcon,
      extensaoArquivo: "",
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        nome: "",
        situacao: 1,
        imagem: null,
      },
    }
  },
  async beforeMount() {
    this.$fotoProdutoService = new FotoProdutoService()

    if (this.idFoto) {
      this.$fotoProdutoService.findById(this.idFoto).then(response => {
        var dataURL = "data:image/jpeg;base64," + response.data.arquivo

        this.form = response.data
        this.form.imagem = dataURL

      })
    }
  },

  computed: {
    mostrarImagem() {
      return this.form.imagem && this.form.imagem != null
    },
  },

  methods: {
    visualizarImagem(event) {
      this.form.imagem = null

      var file = event.target.files[0]
      if (file) {
        var reader = new FileReader()
        reader.onload = e => {
          this.form.imagem = e.target.result
        }
        const fileName = file.name
        this.extensaoArquivo = fileName.substring(fileName.lastIndexOf('.'))
        reader.readAsDataURL(file)
      }
    },

    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1])
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0]
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    salvar() {
      if (!this.form.imagem) {
        this.$notify({
          type: "danger",
          message: "Selecione uma imagem",
        })

        return
      }

      if (!this.form.nome || this.form.nome == "") {
        this.$notify({
          type: "danger",
          message: "Descrição é obrigatória",
        })

        return
      }

      if (!this.form.situacao) {
        this.$notify({
          type: "danger",
          message: "Situação é obrigatória",
        })
        return
      }

      var formData = new FormData()
      formData.append("idProduto", this.id)
      formData.append("respCriacao", getContext().usuario.nome)
      formData.append("situacao", this.form.situacao)
      formData.append("imagem", this.dataURItoBlob(this.form.imagem))
      formData.append("nome", this.form.nome + this.extensaoArquivo)
      if (this.idFoto) {
        formData.append("id", this.idFoto)
      }
      this.$fotoProdutoService.save(formData).then(response => {
        this.$notify({
          type: "success",
          message: response.data,
        })
        this.fecharModal()
      })
    },
    fecharModal() {
      this.$emit("fecharModal")
    },

  },
}
</script>
<style>
.hand-pointer {
  cursor: pointer;
}
</style>
